import React, { Children, useEffect, useLayoutEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchAndFilter from "../../../component/SearchAndFilter/SearchAndFilter";
import { filters } from "../../../utils/data";
import { useParams } from "react-router-dom";
import {
  setInvestorLiked,
  setInvestorRequestConnection,
} from "../../../store/investorsWithFirms";
import { FixedSizeList as List } from "react-window";
import { mapValues } from "lodash";

const DashboardType = ({}) => {
  const { type } = useParams();
  const investors = useSelector((state) => state.investors);
  const firms = useSelector((state) => state.firms);
  const dispatch = useDispatch();
  const [mousePos, setmousePos] = useState({
    x: 0,
    y: 0,
  });
  const investorsWithFirms = useSelector((state) => state.investorsWithFirms);
  // console.log("here=>", investorsWithFirms || "na");

  // const [search, setsearch] = useState("");

  const [search_page, setsearch_page] = useState({
    investors: "",
    banker: "",
    debt: "",
  });

  // const [showing_filters, setshowing_filters] = useState([]);
  // const [current_filters, setcurrent_filters] = useState({});

  const [showing_filters_page, setshowing_filters_page] = useState({
    investor: [],
    banker: [],
    debt: [],
  });
  const [current_filters_page, setcurrent_filters_page] = useState({
    investor: {},
    banker: {},
    debt: {},
  });
  console.log(current_filters_page);

  const [open_accordian_person_id, setopen_accordian_person_id] = useState();

  const [list, setlist] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [TotalPages, setTotalPages] = useState(0);
  // console.log(showing_filters[4]?.children);

  useEffect(() => {
    // setcurrent_filters({ ...filters });
    // setcurrent_filters_page({
    //   investor: { ...filters },
    //   banker: { ...filters },
    //   debt: { ...filters },
    // });
    // setshowing_filters([]);
    setshowing_filters_page({
      investor: [],
      banker: [],
      debt: [],
    });
    // return () => {
    //   // setcurrent_filters({ ...filters });
    //   setcurrent_filters_page({
    //     investor: { ...filters },
    //     banker: { ...filters },
    //     debt: { ...filters },
    //   });
    //   // setshowing_filters([]);
    //   setshowing_filters_page({
    //     investor: [],
    //     banker: [],
    //     debt: [],
    //   });
    // };
  }, []);
  useLayoutEffect(() => {
    let local_current_filters = localStorage.getItem("accel_filters");
    local_current_filters = !local_current_filters
      ? ""
      : JSON.parse(local_current_filters);
    console.log({ local_current_filters });
    if (local_current_filters) {
      setcurrent_filters_page(local_current_filters);
    } else {
      setcurrent_filters_page({
        investor: { ...filters },
        banker: { ...filters },
        debt: { ...filters },
      });
    }
    let local_search = localStorage.getItem("accel_search");

    local_search = !local_search ? "" : JSON.parse(local_search);
    if (local_search) {
      setsearch_page(local_search);
    }
  }, []);

  useEffect(() => {
    if (investorsWithFirms?.data?.length > 0) {
      let new_list = [];

      let filters = {
        "Funding Round": [],
        Sector: [],
        City: [],
        Country: [],
        Designation: [],
      };
      // setopen_accordian_person_id("");
      investorsWithFirms.data.forEach((item) => {
        let filterd_investors = (item?.investors || []).filter((people) => {
          let f_type = type ? people.type.toLowerCase() == type : true;
          let f_fundingRound =
            current_filters_page?.[type]?.["Funding Round"] &&
            current_filters_page?.[type]?.["Funding Round"].length
              ? people?.stage?.some((ele) =>
                  current_filters_page?.[type]?.["Funding Round"].includes(
                    ele.trim()
                  )
                )
              : true;
          let f_sector =
            current_filters_page?.[type]?.["Sector"] &&
            current_filters_page?.[type]?.["Sector"].length
              ? people?.sector?.some((ele) =>
                  current_filters_page?.[type]?.["Sector"].includes(ele.trim())
                )
              : true;

          let f_city =
            current_filters_page?.[type]?.["City"] &&
            current_filters_page?.[type]?.["City"].length
              ? people?.locationCities?.some((ele) =>
                  current_filters_page?.[type]?.["City"].includes(ele.trim())
                )
              : true;
          let f_country =
            current_filters_page?.[type]?.["Country"] &&
            current_filters_page?.[type]?.["Country"].length
              ? people?.locationCountries?.some((ele) =>
                  current_filters_page?.[type]?.["Country"].includes(ele.trim())
                )
              : true;
          let f_designation =
            current_filters_page?.[type]?.["Designation"] &&
            current_filters_page?.[type]?.["Designation"].length
              ? current_filters_page?.[type]?.["Designation"].includes(
                  people?.designation?.trim()
                )
              : true;
          // console.log(item,people);

          let f_search = search_page[type]
            ? [
                people.name || "",
                people.locationCountries || "",
                people.designation || "",
                item.firmName,
              ]
                .join(", ")
                .toLowerCase()
                .match(search_page[type])
            : true;
          let flag =
            f_type &&
            f_fundingRound &&
            f_sector &&
            f_city &&
            f_country &&
            f_designation &&
            f_search;
          filters["Funding Round"].push(...(people?.stage || []));
          // if (flag) {
          filters["Sector"].push(...(people?.sector || []));
          filters["City"].push(...(people?.locationCities || []));
          filters["Country"].push(...(people?.locationCountries || []));
          filters["Designation"].push(people?.designation || "");
          // }
          return flag;
        });
        if (filterd_investors.length > 0) {
          new_list.push({ ...item, investors: filterd_investors });
        }
      });

      const companiesPerPage = 10;
      let totalPages = Math.ceil(new_list.length / companiesPerPage);
      const indexOfLastCompany = currentPage * companiesPerPage;
      const indexOfFirstCompany = indexOfLastCompany - companiesPerPage;
      const currentCompanies = new_list.slice(
        indexOfFirstCompany,
        indexOfLastCompany
      );

      setlist(currentCompanies);
      setTotalPages(totalPages);
      // setshowing_filters([
      //   {
      //     title: "Funding Round",
      //     children: [...new Set(filters["Funding Round"])].sort((a, b) =>
      //       a.localeCompare(b)
      //     ),
      //     count: filters["Funding Round"].length,
      //   },
      //   {
      //     title: "Sector",
      //     children: [...new Set(filters["Sector"])].sort((a, b) =>
      //       a.localeCompare(b)
      //     ),
      //     count: filters["Sector"].length,
      //   },
      //   {
      //     title: "Country",
      //     children: [...new Set(filters["Country"])].sort((a, b) =>
      //       a.localeCompare(b)
      //     ),
      //     count: filters["Country"].length,
      //   },
      //   {
      //     title: "City",
      //     children: [...new Set(filters["City"])].sort((a, b) =>
      //       a.localeCompare(b)
      //     ),
      //     count: filters["City"].length,
      //   },
      //   {
      //     title: "Designation",
      //     // children: [...new Set(filters["Designation"])].sort((a, b) =>
      //     //   a.localeCompare(b)
      //     // ),
      //     children: [
      //       "Managing Director",
      //       "Partner",
      //       "Director",
      //       "Principal",
      //       "Senior Vice President",
      //       "Vice President",
      //       "Investment Professional",
      //       "Fund Manager",
      //       "Associate",
      //       "Analyst",
      //     ],
      //     count: filters["Designation"].length,
      //   },
      // ]);
      setshowing_filters_page((prev) => ({
        ...prev,
        [type]: [
          {
            title: "Funding Round",
            children: [...new Set(filters["Funding Round"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Funding Round"].length,
          },
          {
            title: "Sector",
            children: [...new Set(filters["Sector"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Sector"].length,
          },
          {
            title: "Country",
            children: [...new Set(filters["Country"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["Country"].length,
          },
          {
            title: "City",
            children: [...new Set(filters["City"])].sort((a, b) =>
              a.localeCompare(b)
            ),
            count: filters["City"].length,
          },
          {
            title: "Designation",
            // children: [...new Set(filters["Designation"])].sort((a, b) =>
            //   a.localeCompare(b)
            // ),
            children: [
              "Managing Director",
              "Partner",
              "Director",
              "Principal",
              "Senior Vice President",
              "Vice President",
              "Investment Professional",
              "Fund Manager",
              "Associate",
              "Analyst",
            ],
            count: filters["Designation"].length,
          },
        ],
      }));
    } else {
    }
    return () => {
      setlist([]);
    };
  }, [
    investorsWithFirms,
    type,
    //  current_filters,
    search_page,
    current_filters_page,
    currentPage,
  ]);
  // console.table(showing_filters);
  useEffect(() => {
    setCurrentPage(1);
  }, [
    // current_filters,
    current_filters_page,
    //  search,
    search_page,
    type,
  ]);

  const handleNextPage = () => {
    if (currentPage < TotalPages) {
      setCurrentPage(currentPage + 1);
    }
  };

  const handlePrevPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  };
  // console.log(current_filters);
  return (
    <>
      <div className="subheader">
        <div>
          <div className="txt1">
            Find your next investment{" "}
            {{ banker: " banker" }[type] || " partner"}
          </div>
          <div className="txt2">
            Great things happen together. Tap into our expansive network of
            {{ banker: " banker" }[type] || " investors and funds"}!
          </div>
        </div>
      </div>

      <div className="s_f_section">
        {currentPage != TotalPages || TotalPages > 1 ? (
          <div className="s_f_pagination">
            <div
              className={`s_f_arraow ${currentPage === 1 ? "disabled" : ""}`}
              onClick={handlePrevPage}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xlink="http://www.w3.org/1999/xlink"
                width="21"
                height="21"
                x="0"
                y="0"
                viewBox="0 0 128 128"
                space="preserve"
                class=""
              >
                <g>
                  <path
                    d="M84 108a3.988 3.988 0 0 1-2.828-1.172l-40-40a3.997 3.997 0 0 1 0-5.656l40-40c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656L49.656 64l37.172 37.172a3.997 3.997 0 0 1 0 5.656A3.988 3.988 0 0 1 84 108z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                    class=""
                  ></path>
                </g>
              </svg>
            </div>

            <div>
              {currentPage} of {TotalPages}
            </div>
            <div
              className={`s_f_arraow right ${
                currentPage === TotalPages ? "disabled" : ""
              }`}
              onClick={handleNextPage}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                version="1.1"
                xlink="http://www.w3.org/1999/xlink"
                width="21"
                height="21"
                x="0"
                y="0"
                viewBox="0 0 128 128"
                space="preserve"
                class=""
              >
                <g>
                  <path
                    d="M84 108a3.988 3.988 0 0 1-2.828-1.172l-40-40a3.997 3.997 0 0 1 0-5.656l40-40c1.563-1.563 4.094-1.563 5.656 0s1.563 4.094 0 5.656L49.656 64l37.172 37.172a3.997 3.997 0 0 1 0 5.656A3.988 3.988 0 0 1 84 108z"
                    fill="#000000"
                    opacity="1"
                    data-original="#000000"
                    class=""
                  ></path>
                </g>
              </svg>
            </div>
          </div>
        ) : (
          ""
        )}

        <SearchAndFilter
          {...{
            replacetxt: type == "banker" ? { "Funding Round": "Stage" } : {},
            count: list?.length,
            search: search_page[type] || "",
            setsearch: (txt) => {
              setsearch_page((prev) => {
                let obj = {
                  ...prev,
                  [type]: txt,
                };
                localStorage.setItem("accel_search", JSON.stringify(obj));
                return obj;
              });
            },
            showing_filters: showing_filters_page?.[type] || [],
            current_filters: current_filters_page?.[type] || {},
            clear_filters: () => {
              setcurrent_filters_page((prev) => {
                let obj = {
                  ...prev,
                  [type]: {
                    ...filters,
                  },
                };
                localStorage.setItem("accel_filters", JSON.stringify(obj));
                return obj;
              });
            },
            setcurrent_filters: (key, value) => {
              setcurrent_filters_page((prev) => {
                let obj = {
                  ...prev,
                  [type]: {
                    ...prev[type],
                    [key]: prev?.[type]?.[key]?.includes(value)
                      ? prev?.[type]?.[key]?.filter((el) => el != value)
                      : [...prev[type][key], value],
                  },
                };
                localStorage.setItem("accel_filters", JSON.stringify(obj));
                return obj;
              });
            },
            filter_modal: true,
          }}
        />
      </div>

      <div className="main_body">
        <div className="table">
          {!list?.length ? (
            <div className="table_main">
              <div className="table_body">No data available</div>
            </div>
          ) : (
            <div className="table_main">
              <div className="table_body">
                {/* <List height={600} itemCount={2000} itemSize={10} width={1000}>
                  {InvestorCell} */}
                {mousePos?.remarks ? (
                  <div
                    className=" float_remark"
                    style={{
                      top: mousePos?.y ? mousePos?.y - 50 : 0,
                      left: mousePos?.x ? mousePos?.x + 10 : 0,
                    }}
                  >
                    <div className="title">Remarks</div>
                    <div>{mousePos?.remarks || "NA"}</div>
                  </div>
                ) : (
                  ""
                )}
                {list?.map(
                  ({ website, logo, firmName, investors, _id }, index) => (
                    <div key={index} className="cards">
                      <div
                        className="partner_group"
                        onClick={() => {
                          return window.open(website);
                        }}
                      >
                        <img src={logo} />
                        <div className="partner_name">
                          <div className="txt">{firmName}</div>
                        </div>
                      </div>
                      <div className="people_group">
                        {investors?.map((people) => (
                          <div
                            className="people_card"
                            onMouseMove={(e) => {
                              console.log(e.clientX, e.clientY, e.target);
                              setmousePos({
                                x: e.clientX,
                                y: e.clientY,
                                remarks: people?.remarks,
                              });
                            }}
                          >
                            <div
                              className="people_card_main"
                              onClick={() => {
                                setopen_accordian_person_id(type + people._id);
                              }}
                            >
                              <div
                                className="people_img"
                                style={{
                                  backgroundImage: `url('${people.photo}')`,
                                }}
                              >
                                <div
                                  className="favorite"
                                  active={(
                                    investorsWithFirms.liked.includes(
                                      people._id
                                    ) || false
                                  ).toString()}
                                  onClick={() => {
                                    dispatch(
                                      setInvestorLiked({
                                        investorId: people._id,
                                        liked:
                                          investorsWithFirms.liked.includes(
                                            people._id
                                          ) || false,
                                      })
                                    );
                                  }}
                                >
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    id="icon-import"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                  >
                                    <link
                                      xmlns=""
                                      type="text/css"
                                      rel="stylesheet"
                                      id="dark-mode-custom-link"
                                    />
                                    <link
                                      xmlns=""
                                      type="text/css"
                                      rel="stylesheet"
                                      id="dark-mode-general-link"
                                    />
                                    <style
                                      xmlns=""
                                      lang="en"
                                      type="text/css"
                                      id="dark-mode-custom-style"
                                    />
                                    <style
                                      xmlns=""
                                      lang="en"
                                      type="text/css"
                                      id="dark-mode-native-style"
                                    />
                                    <style
                                      xmlns=""
                                      lang="en"
                                      type="text/css"
                                      id="dark-mode-native-sheet"
                                    />
                                    <path
                                      d="M11 4.99999L12 6L13 5C15.2091 2.79086 18.7909 2.79086 21 5C23.2091 7.20914 23.2091 10.7909 21 13L12 22L2.99999 13C0.790855 10.7909 0.790855 7.20913 2.99999 5C5.20913 2.79086 8.79085 2.79085 11 4.99999Z"
                                      stroke="var(--stroke-color, black)"
                                      strokeWidth="var(--stroke-width, 1.5)"
                                      vectorEffect="non-scaling-stroke"
                                    />
                                  </svg>
                                </div>
                              </div>
                              <div className="people_details">
                                <div className="people_name">
                                  {people?.name || "-"}
                                </div>
                                <div className="people_designation">
                                  {people?.designation || "-"}
                                </div>
                                <div className="people_location">
                                  {people?.locationCountries || "-"}
                                </div>
                                <style>{filters["Funding Round"]}</style>
                                <div className="chip_group">
                                  {people?.stage
                                    ? people.stage.map((el) => (
                                        <div className="chip_item" type={el}>
                                          {el}
                                        </div>
                                      ))
                                    : "-"}
                                </div>
                              </div>
                              <div
                                className="people_action"
                                onClick={(e) => e.stopPropagation()}
                              >
                                <div
                                  className="request_connection"
                                  active={(
                                    investorsWithFirms.requestConnection.includes(
                                      people._id
                                    ) || false
                                  ).toString()}
                                  onClick={() => {
                                    dispatch(
                                      setInvestorRequestConnection({
                                        investorId: people._id,
                                      })
                                    );
                                  }}
                                >
                                  {investorsWithFirms.requestConnection.includes(
                                    people._id
                                  ) ? (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        version="1.1"
                                        xlink="http://www.w3.org/1999/xlink"
                                        width="20"
                                        height="20"
                                        x="0"
                                        y="0"
                                        viewBox="0 0 24 24"
                                        class=""
                                      >
                                        <g>
                                          <path
                                            d="M9.707 19.121a.997.997 0 0 1-1.414 0l-5.646-5.647a1.5 1.5 0 0 1 0-2.121l.707-.707a1.5 1.5 0 0 1 2.121 0L9 14.171l9.525-9.525a1.5 1.5 0 0 1 2.121 0l.707.707a1.5 1.5 0 0 1 0 2.121z"
                                            fill="green"
                                            opacity="1"
                                            data-original="green"
                                            class=""
                                          ></path>
                                        </g>
                                      </svg>
                                      Request Connection
                                    </>
                                  ) : (
                                    <>
                                      <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        id="icon-import"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                      >
                                        <link
                                          xmlns=""
                                          type="text/css"
                                          rel="stylesheet"
                                          id="dark-mode-custom-link"
                                        />
                                        <link
                                          xmlns=""
                                          type="text/css"
                                          rel="stylesheet"
                                          id="dark-mode-general-link"
                                        />
                                        <style
                                          xmlns=""
                                          lang="en"
                                          type="text/css"
                                          id="dark-mode-custom-style"
                                        />
                                        <style
                                          xmlns=""
                                          lang="en"
                                          type="text/css"
                                          id="dark-mode-native-style"
                                        />
                                        <style
                                          xmlns=""
                                          lang="en"
                                          type="text/css"
                                          id="dark-mode-native-sheet"
                                        />
                                        <path
                                          vectorEffect="non-scaling-stroke"
                                          d="M11.45 14.1667H4.13116C3.28443 14.1667 2.81822 13.1801 3.35874 12.5283L12.1765 1.8959C12.831 1.10674 14.1076 1.69622 13.9313 2.70618L12.6875 9.83333H19.9122C20.752 9.83333 21.2178 10.8058 20.6914 11.4601L12.1268 22.1075C11.4864 22.9036 10.2051 22.3401 10.359 21.3301L11.45 14.1667Z"
                                          stroke="var(--stroke-color, black)"
                                          strokeWidth="var(--stroke-width, 1)"
                                        />
                                      </svg>
                                      Request Connection
                                    </>
                                  )}
                                </div>
                              </div>
                            </div>
                            {/* {people?.remarks ? (
                              <div className="people_card_main float_remark">
                                <div className="title">Remarks</div>
                                <div>{people?.remarks || "NA"}</div>
                              </div>
                            ) : (
                              ""
                            )} */}
                            <div
                              className="people_card_details"
                              active={(
                                type + people._id ==
                                open_accordian_person_id
                              ).toString()}
                            >
                              <div className="people_card_details_main">
                                <div className="details_item">
                                  <div className="title">Email</div>
                                  <div className="body">
                                    {people?.email || "NA"}
                                  </div>
                                </div>
                                {people?.locationCities?.length &&
                                people?.locationCities?.join("").length ? (
                                  <div className="details_item">
                                    <div className="title">Cities</div>
                                    <div className="body multiple">
                                      {people?.locationCities?.length
                                        ? people?.locationCities?.map((el1) => (
                                            <div>{el1}</div>
                                          ))
                                        : "NA"}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {people?.pastInvestments?.length &&
                                people?.pastInvestments?.join("").length ? (
                                  <div className="details_item">
                                    <div className="title">
                                      PastI Investments
                                    </div>
                                    <div className="body multiple">
                                      {people?.pastInvestments?.length
                                        ? people?.pastInvestments?.map(
                                            (el1) => <div>{el1}</div>
                                          )
                                        : "NA"}
                                    </div>
                                  </div>
                                ) : (
                                  ""
                                )}
                                {
                                  <div className="details_item">
                                    <div className="title">Sector</div>
                                    <div className="body multiple">
                                      {people?.sector?.length
                                        ? people?.sector?.map((el1) => (
                                            <div>{el1}</div>
                                          ))
                                        : "NA"}
                                    </div>
                                  </div>
                                }
                                {people?.linkedIn ? (
                                  <div
                                    className="linkedin"
                                    onClick={() => window.open(people.linkedIn)}
                                  >
                                    <svg
                                      width="70"
                                      height="39"
                                      viewBox="0 0 513 129"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <path
                                        d="M202.242 75.6155L230.493 110.358H208.185L183.042 78.4498V110.358H164.756V18.9298H183.042V72.6898L206.265 46.3583H229.579L202.242 75.6155ZM129.099 44.5298C120.972 44.6513 113.421 48.7512 108.893 55.5012V46.3583H91.6131V110.358H109.899V80.4612C109.413 76.0747 110.772 71.6836 113.65 68.3376C116.528 64.9917 120.666 62.9916 125.076 62.8155C135.682 62.8155 137.327 73.2383 137.327 80.4612V110.358H155.613V76.4383C155.613 56.324 148.939 44.5298 129.465 44.5298H129.099ZM292.756 79.8212C292.826 81.1612 292.826 82.504 292.756 83.844H244.756V84.484C246.365 92.3598 253.456 97.9007 261.487 97.5583C267.719 97.8292 273.793 95.5516 278.31 91.2498L290.47 100.393C282.677 108.346 271.882 112.63 260.756 112.187C251.537 112.77 242.517 109.329 236.029 102.753C229.541 96.1769 226.221 87.112 226.927 77.9012C226.738 68.8169 230.334 60.0627 236.853 53.7338C243.373 47.4049 252.23 44.0709 261.305 44.5298C278.493 44.5298 292.756 56.6898 292.756 79.8212ZM275.75 71.9583C275.615 68.2984 273.981 64.8549 271.232 62.4346C268.483 60.0143 264.861 58.8297 261.213 59.1583C253.173 58.2891 245.893 63.9519 244.756 71.9583H275.75ZM18.4703 18.9298H0.18457V110.358H55.0417V92.0726H18.4703V18.9298ZM347.613 18.9298H365.899V110.358H348.619V103.958C344.169 109.44 337.387 112.492 330.333 112.187C321.744 111.966 313.626 108.211 307.897 101.807C302.169 95.4032 299.337 86.9192 300.07 78.3583C299.197 69.7819 301.968 61.2332 307.706 54.7996C313.444 48.3659 321.622 44.6394 330.242 44.5298C336.656 44.2489 342.914 46.5546 347.613 50.9298V18.9298ZM348.985 78.3583C349.566 74.0867 348.27 69.7723 345.43 66.5289C342.59 63.2856 338.484 61.431 334.173 61.444C325.426 62.0791 318.799 69.6012 319.27 78.3583C318.799 87.1155 325.426 94.6375 334.173 95.2727C338.484 95.2856 342.59 93.4311 345.43 90.1877C348.27 86.9444 349.566 82.63 348.985 78.3583ZM73.3274 17.1012C67.2272 17.188 62.2345 21.981 61.8989 28.0726C61.8989 34.3844 67.0156 39.5012 73.3274 39.5012C79.6393 39.5012 84.756 34.3844 84.756 28.0726C84.4203 21.981 79.4277 17.188 73.3274 17.1012ZM64.1846 110.358H82.4703V46.3583H64.1846V110.358ZM512.185 9.7869V119.501C512.185 124.551 508.091 128.644 503.042 128.644H393.327C388.278 128.644 384.185 124.551 384.185 119.501V9.7869C384.185 4.73744 388.278 0.644043 393.327 0.644043H503.042C508.091 0.644043 512.185 4.73744 512.185 9.7869ZM420.756 46.3583H402.47V110.358H420.756V46.3583ZM423.042 28.0726C423.042 21.7608 417.925 16.644 411.613 16.644C405.301 16.644 400.185 21.7608 400.185 28.0726C400.185 34.3844 405.301 39.5012 411.613 39.5012C417.925 39.5012 423.042 34.3844 423.042 28.0726ZM493.899 76.4383C493.899 56.324 487.225 44.5298 467.75 44.5298C459.493 44.5308 451.78 48.6448 447.179 55.5012V46.3583H429.899V110.358H448.185V80.4612C447.699 76.0747 449.058 71.6836 451.936 68.3376C454.813 64.9917 458.952 62.9916 463.362 62.8155C473.967 62.8155 475.613 73.2383 475.613 80.4612V110.358H493.899V76.4383Z"
                                        fill="#0A66C2"
                                      />
                                    </svg>
                                  </div>
                                ) : (
                                  ""
                                )}
                              </div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )
                )}
                {/* </List> */}
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default DashboardType;
